import { and, asc, desc, eq, ne } from "drizzle-orm";
import {
  order,
  order_line,
  order_line_modifier,
  payment,
  type PowerSyncDrizzleDB,
} from "@comandero/powersync";
import {
  liveOrderFilters,
  liveOrderLineFilters,
  liveOrderLineModifierFilters,
  livePaymentFilters,
} from "../live/filters";

export function getOrdersQuery(
  db: PowerSyncDrizzleDB,
  organizationId: string,
  branchId: string,
  status?: "open" | "sent" | "paid" | "void",
) {
  const filters = [
    eq(order.organization_id, organizationId),
    eq(order.branch_id, branchId),
    ...liveOrderFilters(),
  ];
  if (status) {
    filters.push(eq(order.status, status));
  }
  return db
    .select()
    .from(order)
    .where(and(...filters))
    .orderBy(desc(order.opened_at));
}

// Lookup id-scoped (keyed): detalle por id; ver una fila borrada es inocuo.
export function getOrderByIdQuery(db: PowerSyncDrizzleDB, orderId: string) {
  return db.select().from(order).where(eq(order.id, orderId)).limit(1);
}

export function getOrderLinesQuery(db: PowerSyncDrizzleDB, orderId: string) {
  return db
    .select()
    .from(order_line)
    .where(and(eq(order_line.order_id, orderId), ...liveOrderLineFilters()))
    .orderBy(order_line.sort_order, order_line.created_at);
}

export function getOrderLineModifiersQuery(db: PowerSyncDrizzleDB, lineId: string) {
  return db
    .select()
    .from(order_line_modifier)
    .where(and(eq(order_line_modifier.order_line_id, lineId), ...liveOrderLineModifierFilters()));
}

export function getPaymentsForOrderQuery(db: PowerSyncDrizzleDB, orderId: string) {
  return db
    .select()
    .from(payment)
    .where(and(eq(payment.order_id, orderId), ...livePaymentFilters()));
}

/**
 * Comandas para el KDS: órdenes enviadas a cocina (status `sent`) de una
 * sucursal, más recientes primero. El KDS lista sus líneas y avanza estados.
 */
export function getKitchenOrdersQuery(
  db: PowerSyncDrizzleDB,
  organizationId: string,
  branchId: string,
) {
  return db
    .select()
    .from(order)
    .where(
      and(
        eq(order.organization_id, organizationId),
        eq(order.branch_id, branchId),
        eq(order.status, "sent"),
        ...liveOrderFilters(),
      ),
    )
    .orderBy(asc(order.opened_at));
}

/** Líneas de cocina de una orden que aún no están servidas. */
export function getKitchenLinesQuery(db: PowerSyncDrizzleDB, orderId: string) {
  return db
    .select()
    .from(order_line)
    .where(
      and(
        eq(order_line.order_id, orderId),
        ne(order_line.kds_status, "served"),
        ...liveOrderLineFilters(),
      ),
    )
    .orderBy(order_line.sort_order, order_line.created_at);
}
